import { Reveal } from "@/components/Reveal";

const POSTER = "/assets/foto-libera-hero.jpg";

export const Author = () => (
  <section id="metodo" className="py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal>
        <div className="relative mx-auto max-w-md">
          <div className="absolute -left-6 -top-6 h-full w-full rounded-[2rem] border border-terracotta/30" />
          <video
            poster={POSTER}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="relative aspect-[4/5] w-full rounded-[2rem] object-cover shadow-xl shadow-espresso/15"
            data-testid="author-video"
          >
            <source src="/assets/video-libera.mp4" type="video/mp4" />
            <source src="/assets/video-libera.webm" type="video/webm" />
          </video>
          <div className="absolute -bottom-6 -right-4 rounded-2xl bg-terracotta px-6 py-4 shadow-xl sm:-right-8">
            <p className="font-serif text-lg italic text-linen">Hellen</p>
            <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-linen/80">Mamma · Imprenditrice · Ristorazione</p>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-terracotta">Chi ha creato il metodo</span>
        <h2 className="mt-4 font-serif text-2xl tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Vent'anni di ristorazione mi hanno insegnato a fare tutto.
          <span className="block italic text-terracotta">Ed era proprio questo il problema.</span>
        </h2>
        <div className="mt-6 space-y-5 text-base leading-relaxed text-taupe">
          <p>
            Sono mamma e imprenditrice nella ristorazione da più di vent'anni. In tutto questo tempo ho imparato
            a fare qualsiasi cosa: aggiustare un gestionale che non funziona, sistemare un cavo elettrico che non va,
            guidare un team, capire le esigenze dei clienti prima ancora che le dicano.
          </p>
          <p>
            Ero diventata <strong className="font-semibold text-ink">indispensabile</strong>. Ero ovunque, sempre, per tutti.
            Tranne che per me. Perché quando sai fare tutto, tutto finisce per dipendere da te —
            e la tua attività smette di essere un'impresa e diventa una gabbia.
          </p>
          <p>
            Il cambiamento non è arrivato lavorando di più, ma smettendo di esserci ovunque:
            una procedura scritta, una responsabilità condivisa, un'ora restituita a me stessa. Poi un'altra. Poi un'altra ancora.
          </p>
          <p>
            Questo percorso è esattamente il metodo che ho usato io: sette giorni, un passo alla volta,
            per costruire un'attività solida che non dipenda soltanto da te. Perché la libertà non si sogna. Si costruisce.
          </p>
        </div>
        <div className="mt-10" data-testid="author-signature">
          <p className="-rotate-2 font-script text-4xl leading-tight text-terracotta sm:text-5xl">Hellen Gebremeskel</p>
          <svg viewBox="0 0 260 22" className="mt-1 h-5 w-56 -rotate-2 text-terracotta/70 sm:w-64" aria-hidden="true">
            <path d="M6 14 C 70 4, 150 2, 254 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <path d="M214 12 C 232 14, 244 16, 252 19" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
          </svg>
        </div>
      </Reveal>
    </div>
  </section>
);
